<div [class]="mainClassList()"></div>

<div class="relative h-full w-full">
  <div
    #list
    cdkDropListGroup
    class="bg-page relative flex h-full w-full gap-2 overflow-x-auto overflow-y-hidden p-2">
    @if (lists$()) {
      @for (list of lists$(); track list.id) {
        <app-list
          [enableEdit]="allowEdit()"
          [enableMarkTaskAsDone]="allowTaskDone()"
          [enableButtonLinkToMap]="addExternalMapButton()"
          [enableExport]="allowExport()"
          [list]="list.list"
          [fullScreen]="fullScreen()"
          [optionsMenu]="true"
          (exportOutput)="exportPrimaryAggregator($event)"
          (hide)="unselectList(list.list.aggregatorId)" />
      }

      @if (lists$().length === 0 && showAll()) {
        <div class="flex-1">
          <div class="mx-auto w-3/5 pt-20 text-center">
            <i class="text-text-primary ph-bold ph-plugs mx-auto text-6xl"></i>
            <p class="text-text-primary p-2">
              {{ 'visualization.list.no_list' | translate }}
            </p>
          </div>
        </div>
      }

      @if (lists$().length === 0 && !showAll()) {
        <div class="flex-1">
          <div class="mx-auto w-3/5 pt-20 text-center">
            <i class="text-text-primary ph-bold ph-columns mx-auto text-6xl"></i>
            <p class="text-text-primary p-2">
              {{ 'visualization.list.select_list' | translate }}
            </p>
          </div>
        </div>
      }

      @if (lists$().length === 1 && !showAll()) {
        <div class="flex-1">
          <div class="w-72 pt-20 text-center">
            <i class="text-text-primary ph-bold ph-swap mx-auto text-6xl"></i>
            <p class="text-text-primary mx-auto w-52 p-2">
              {{ 'visualization.list.select_other_swap' | translate }}
            </p>
          </div>
        </div>
      }
    } @else {
      <div class="flex-1">
        <div class="mx-auto w-3/5 pt-20 text-center">
          <i class="text-text-primary ph-bold ph-plugs mx-auto text-6xl"></i>
          <p class="text-text-primary p-2">
            {{ 'visualization.list.not_available' | translate }}
          </p>
        </div>
      </div>
    }
  </div>

  <div
    class="shrink-0 grow-0 bg-zinc-50 hover:bg-zinc-200 dark:bg-zinc-800 dark:hover:bg-zinc-600"
    [class.w-5]="!fullScreen()"
    [class.w-0]="fullScreen()"
    (mouseover)="startScroll(10)"
    (mouseout)="stopScroll()"
    (blur)="stopScroll()"
    (focus)="startScroll(10)"
    (dragover)="startScroll(-5)"
    (dragleave)="stopScroll()"></div>

  @if (!showAll()) {
    <div class="absolute right-2 bottom-2 z-10">
      <button
        #addListTrigger
        (click)="toggleAddListDropdown()"
        [attr.aria-expanded]="isAddListDropdownOpen()"
        [disabled]="dropdownItems$().length === 0"
        aria-haspopup="true"
        class="btn-primary duration-base flex h-8 cursor-pointer items-center justify-center rounded-md px-2 py-2 text-sm font-medium transition-all disabled:cursor-not-allowed disabled:opacity-50"
        type="button">
        <i [class]="ICONS.plus"></i>
      </button>

      <app-dropdown
        [target]="addListTrigger"
        [template]="addListDropdownContent"
        [isOpen]="isAddListDropdownOpen()"
        [onClose]="onCloseAddListDropdown"
        [position]="'top'"
        [closeOnClickOutside]="true"
        [closeOnEscape]="true" />

      <app-tooltip
        [target]="addListTrigger"
        [content]="'visualization.list.add_tooltip' | translate"
        [position]="'top'" />
    </div>
  }
</div>

<ng-template #addListDropdownContent>
  <app-items-dropdown [items]="dropdownItems$()" />
</ng-template>
